import { VRouter } from '@/main';
import { AuthService } from '@/services';

export default (error) => {
  if (error) {
    const response = error.response;
    const status = response?.status;

    console.log('ERROR MIDDLEWARE: ', response);
    switch (status) {
      case 401:
        AuthService.logOut();
        VRouter.push('/log-in');
        break;
      case 404:
        VRouter.app.$notify({
          type: 'error',
          title: 'Not Found',
          text:
            String(response.data).length > 20
              ? 'Sorry, requested not found.'
              : response.data
        });
        break;
      case 408:
        AuthService.logOut();
        VRouter.app.$notify({
          type: 'error',
          title: 'Link expired',
          text: 'Your protected access link has been expired',
          duration: 15000
        });
        VRouter.push('/log-in');
        break;
      case 409:
        VRouter.app.$notify({
          type: 'error',
          title: error.statusText,
          text: response.data.description
        });
        break;
      case 403:
        if (response.data.error === 'NOT_ALL_ROWS_ARE_READY_FOR_IMPORT') {
          VRouter.app.$notify({
            type: 'error',
            title: 'Error',
            duration: 3000,
            text: 'Not all selected rows are ready for import.'
          });
        }
        break;

      default:
        VRouter.app.$notify({
          type: 'error',
          title: error.title,
          text:
            response?.data ||
            error.message ||
            'Unable to complete the request. Please try again.'
        });
        break;
    }
    throw error;
  }
};
